<section class="video-area ptb-100 jarallax" data-jarallax='{"speed": 0.3}'>
    <div class="container">
        <div class="video-content">
            
        </div>
    </div>
</section>